import { ThesisAssignedList } from "../../components/datatable/ThesisAssignedList"
import { Navbar } from "../../components/navbar/Navbar"
import { Sidebar } from "../../components/sidebar/Sidebar"
import "./examinerHome.scss"

export const ExaminerHome = () => {
  return (
    <div className="list">
    <Sidebar/>
    <div className="listContainer">
        <Navbar/>
        <ThesisAssignedList/>
            
    </div>
    </div>
  )
}


export default ExaminerHome
